import { Observable } from "rxjs";
import { concatMap } from "rxjs/operators";

    /**
     * @description
     *  Permite serializar la emisión de observables, aplicando un proceso de
     *  'flattenization' sobre el primer observable, es decir, si el
     *  observable de entrada es un observable anidado, entonces se emite el
     *  observable interno (inner observable).
     *
     *  Nótese que este operador solo aplana un nivel, y por lo tanto se debe
     *  aplicar una vez por cada anidamiento.
     *
     * @returns
     *  Un observable con un nivel inferior de anidamiento.
     */

export function flattenize<T>(): (source: Observable<Observable<T>>) => Observable<T> {
    return function (source: Observable<Observable<T>>): Observable<T> {
        return source.pipe(
            concatMap(innerObservable => innerObservable)
        );
    };
}
